import styled, { css } from 'styled-components';

import { COLORS as COLORS_OLD } from '@r1-frontend/ui-react/assets/js/constants';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const CommonChannel = styled.div`
    display: block;
    margin-bottom: 32px;
    padding-right: 48px;
    position: relative;
    width: 33.333%;

    @media only screen and (max-width: 1359px) {
        padding-right: 64px;
        width: 50%;
    }

    @media only screen and (max-width: 1023px) {
        padding-right: 0;
        width: 100%;
    }

    &:nth-child(3n) {
        padding-right: 0;

        @media only screen and (max-width: 1359px) {
      padding-right: 64px;
        }

        @media only screen and (max-width: 1023px) {
      padding-right: 0;
        }
    }

    &:nth-child(2n) {
        @media only screen and (max-width: 1359px) {
      padding-right: 0;
        }
    }

    &:last-child {
        margin-bottom: 0;
    }

    &::after {
        background: linear-gradient(360deg, ${COLORS.BgMain} 0%, rgba(255, 255, 255, 0) 87.72%);
        content: "";
        pointer-events: none;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 80px;
        z-index: 0;
    }
`;

export const ChannelDescription = styled.div`
    align-items: stretch;
    border-bottom: 1px solid ${COLORS_OLD.grey};
    display: flex;
    flex-wrap: nowrap;
    padding-bottom: 21px;
    width: 100%;
`;

export const ChannelDescriptionPicture = styled.picture`
    align-items: center;
    display: flex;
    flex-shrink: 0;
    justify-content: center;
    height: 43px;
    margin-right: 16px;
    width: 64px;
`;

export const ChannelDescriptionImage = styled.img`
    max-height: 90%;
    max-width: 90%;
`;

export const ChannelDescriptionContent = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: space-between;
`;

export const ChannelDescriptionLink = styled.a`
    color: ${COLORS.LabelsText_5};
    margin-top: -3px;
    text-decoration: none;
`;

export const ChannelDescriptionTitle = styled.span`
    box-shadow: inset 0 -3px white, inset 0 -4px ${COLORS.LabelsText_5};
    display: inline;
    ${FONTS.L};
`;

export const ChannelDescriptionNumber = styled.div`
    color: ${COLORS.TextPrimary};
    ${FONTS.XS};
    margin-bottom: -5px;
`;

export const BroadcastContainer = styled.div`
    margin-top: 16px;
    max-height: 270px;
    overflow: hidden;
    position: relative;
    width: 100%;
`;

export const BroadcastTime = styled.div`
    flex-shrink: 0;
    margin-right: 16px;
    text-align: center;
    width: 64px;
`;

export const BroadcastTitle = styled.div`
    flex: 1 0;
`;

export const Broadcast = styled.div<{ broadcastStatus: boolean }>`
    align-items: stretch;
    color: ${COLORS.TextPrimary};
    cursor: pointer;
    display: flex;
    ${FONTS.S};
    margin-top: 16px;
    position: relative;
    width: 100%;

    &:first-child {
        margin-top: 0;
    }

    &:last-child {
        margin-bottom: 80px;
    }

    ${({ broadcastStatus }) => broadcastStatus && css`
        color: ${COLORS.TextPrimary};
        margin-top: 14px;
    `}

    ${({ broadcastStatus }) => !broadcastStatus && css`
        ${BroadcastTitle} {
      color: ${COLORS.TextPrimary};
        }
    `}

    &:focus,
    &:active {
        outline: none;

        ${css`
      ${BroadcastTime},
      ${BroadcastTitle} {
        color: ${COLORS_OLD.red};
      }
        `}
    }
`;

export const BroadcastProgress = styled.div`
    background-color: ${COLORS_OLD.grey};
    display: block;
    height: 3px;
    margin-top: 6px;
    width: 100%;
`;

export const BroadcastProgressBar = styled.div`
    background-color: ${COLORS_OLD.lightGreen};
    display: block;
    height: 100%;
    width: 0;
`;
